<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'CHANGE_REVIEW', pageCode: 'ALL' }">
  <app-module-header [showImportExportBtn]="showImportExportBtn" [showLastSync]="false"></app-module-header>
</div>
<div appAccessProvider [accessCode]="{ menuCode: 'CHANGE_REVIEW', pageCode: 'ALL', subPageCode: 'LIST' }">
<p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
      <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}" class="tab-label" translate>lbl_all</span>&nbsp;<span class="iconNumber text-color-secondary">({{ totalRecords ? totalRecords : 0  }})</span>
    </ng-template>
    <ng-template pTemplate="body">
         <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          [uniqueId]="uniqueId"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddProduct()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateReviewStatus($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems] = "bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visible]="visible"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"          
          [isEntity]="isEntity"
          [staticEntity]="'change_review'"
          >
        </app-mi-table>
    </ng-template>
  </p-tabPanel>

</p-tabView>
</div>
